define("settings/routes/subscription/billing/edit", ["exports", "@ember/routing/route", "@ember/service"], function (_exports, _route, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/service"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  // Note: the route's `deactivate` is the real release. This only exists so a missed
  // teardown can't hide the launcher for the whole session, so it is set well past
  // how long anyone spends in a billing form.
  const THIRTY_MINUTES = 30 * 60 * 1000;
  let EditRoute = _exports.default = (_class = class EditRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "integrationsSuppressor", _descriptor3, this);
      _initializerDefineProperty(this, "payment", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
    }
    activate() {
      this.integrationsSuppressor.suppress(THIRTY_MINUTES);
    }
    deactivate() {
      this.integrationsSuppressor.unsuppress();
    }
    async afterModel() {
      //Note: address is loaded into service from parent route.
      this.address.resetForm();

      // Note: Automatically set country to match card.
      if (this.address.addressCollectionEnabledInSettings && !this.address.isSavedAddressValid) {
        const stripeCard = await this.payment.retrieveCard.perform();
        if (stripeCard?.card?.country) {
          this.address.setSelectedCountry(stripeCard.card.country);
        }
      }
    }
    setupController(controller) {
      controller.setProperties({
        currentAccount: this.auth.currentAccount
      });
      this.router.on('routeWillChange', controller.confirmRouteChange.perform);
    }
    resetController(controller) {
      this.router.off('routeWillChange', controller.confirmRouteChange.perform);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "integrationsSuppressor", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});